import React from "react";
import "./Vision.css";

export default function Vision() {
  return (
    <section className="vision">
      <h2>Notre Vision</h2>
      <div className="vision-content" style={{ display: "flex", alignItems: "center", gap: "32px", justifyContent: "center", textAlign: "left" }}>
        <div className="vision-image">
          <img src={require("../../assets/images/vision.png")} alt="Notre vision" loading="lazy" />
        </div>
        <div className="vision-text">
          <p>
            Chez <span style={{ color: "#a020f0", fontWeight: "bold" }}>NEXUS SOLUTIONS</span>, notre vision est simple : rendre le digital accessible a toutes les entreprises ivoiriennes, quelle que soit leur taille. Trop d'entrepreneurs et de PME en Cote d'Ivoire n'ont pas encore de presence en ligne — nous sommes la pour changer ca.
          </p>
          <p>
            Nous croyons qu'un bon site web ou une application mobile bien concue peut transformer une activite locale en une entreprise reconnue. C'est pourquoi nous proposons des solutions sur mesure, livrees rapidement et a des prix adaptes au marche ivoirien — sans compromis sur la qualite.
          </p>
        </div>
      </div>
    </section>
  );
}
